import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, initialize } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { getDiffInMinutes } from 'utils/misc';

import { getSchedules } from 'redux/actions/scheduleActions';
import { SequenceDetails } from 'components/modals/SequenceModal';


class SequenceForm extends Component {
  static propTypes = {
    toggleModal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    getSchedules: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      account_id: PropTypes.number,
      schedule: PropTypes.number,
      launch_date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]).isRequired,
    }).isRequired,
    schedules: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
  };

  async componentDidMount() {
    if (this.props.sequence.id) {
      await this.setInitials();
    }
  }

  async componentDidUpdate(preProps) {
    if (this.props.sequence.id && preProps.sequence.id !== this.props.sequence.id) {
      await this.setInitials();
    }
  }

  async setInitials() {
    const { sequence } = this.props;
    await this.props.getSchedules({ account__id: sequence.account_id });
    const selectedSchedule = this.props.schedules.results.find(s => s.id === sequence.schedule);

    const diffInMinutes = getDiffInMinutes(selectedSchedule?.timezone);
    const launchDate = sequence.launch_date && new Date(moment(sequence.launch_date).add(-diffInMinutes, 'minutes'));

    const initialValues = {
      name: sequence.name,
      launch_date: launchDate,
      schedule: {
        label: selectedSchedule.name,
        value: sequence.schedule,
      },
      validate_contacts: sequence.validate_contacts,
      send_to_risky: sequence.send_to_risky,
    };
    this.props.dispatch(initialize(
      'sequenceCreateBasicForm',
      initialValues,
    ));
  }

  render() {
    const { onSubmit } = this.props;
    return (
      <div className="sequence-create">
        <SequenceDetails
          hasSchedules
          submitBtnText="Update"
          toggleModal={this.props.toggleModal}
          onSubmit={onSubmit}
        />
      </div>
    );
  }
}


export default compose(
  connect(
    state => ({
      sequence: state.sequence,
      schedules: state.schedules,
    }),
    { getSchedules },
  ),
  // we need this to be able to clear form during unmount
  reduxForm({
    form: 'sequenceCreateBasicForm',
  }),
)(SequenceForm);
